import { render, staticRenderFns } from "./ProcessBookings.vue?vue&type=template&id=b076f8d8"
import script from "./ProcessBookings.vue?vue&type=script&lang=js"
export * from "./ProcessBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports